import ProjectHeroPokeMania from "../../../components/ProjectHero/PokeMania/ProjectHeroPokeMania";
import ProjectDetailsPokeMania from "../../../components/ProjectDetails/PokeMania/ProjectDetailsPokeMania";


function ProjectPagePokeMania() {
    return (
        <>
            <ProjectHeroPokeMania />
            <ProjectDetailsPokeMania />
        </>
    )
}

export default ProjectPagePokeMania;